export const TRANSACTION_TYPE = {
  FIAT_TO_SILA: 'fiat_to_sila',
  SILA_TO_SILA: 'sila_to_sila',
  SILA_TO_FIAT: 'sila_to_fiat'
};

export const TRANSACTION_SIDE = {
  CREDIT: 'credit',
  DEBIT: 'debit'
};
